import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

export class ProductSwiper {
	constructor() {
		this.swipers = [];
	}

	init() {
		const sliders = document.querySelectorAll(".block-product-swiper .product-swiper");
		if (!sliders.length) return;

		sliders.forEach((slider) => {
			const swiper = new Swiper(slider, {
				modules: [Navigation, Pagination, Autoplay],
				slidesPerView: 1,
				spaceBetween: 16,
				grabCursor: true,
				loop: true,
				speed: 600,
                freeMode: true,
				navigation: {
					nextEl: slider.querySelector(".swiper-button-next"),
					prevEl: slider.querySelector(".swiper-button-prev"),
				},
				pagination: {
					el: slider.querySelector(".swiper-pagination"),
					clickable: true,
				},
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
                    reverseDirection: slider.classList.contains("reverse"),
				},
				breakpoints: {
					640: { slidesPerView: 2.2, spaceBetween: 20 },
					768: { slidesPerView: 3, spaceBetween: 24 },
					1024: { slidesPerView: 5, spaceBetween: 30 },
				},
			});

			this.swipers.push(swiper);
		});
	}
}

// Auto-init when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
	const productSwiper = new ProductSwiper();
	productSwiper.init();
});
